import { kea } from 'kea'
import PropTypes from 'prop-types';
import { find, map } from 'lodash'
import { selector as configSelector, actions as configActions } from '~/config'

import entities from '~/entities'
import {put} from "redux-saga/effects";

export default kea({
  path : () => ['components', 'shopSelector'],

  actions : ({ constants }) => ({
    selectNewShop: (url, shop) => ({ url, shop }),
  }),

  selectors : ({ constants, selectors }) => ({
    activeShop: [
      () => [
        configSelector,
        entities.selectors.shops
      ],
      (config, shops) => {
        const { activeShop } = config;
        if(activeShop && shops) {
          const shop = find(shops, {url: activeShop});

          if(shop) {
            return shop;
          }
        }
        return null;
      },
      PropTypes.object
    ],
    activeUser: [
      () => [
        configSelector
      ],
      (config) => {
        const { activeUser } = config;
        if(activeUser) {
          return activeUser
        }
        return null;
      },
      PropTypes.object
    ],
    shopChoices: [
      () => [ entities.selectors.shops ],
      (shops) => {
        return map(shops, (shop) => {
          return {value: shop.url, label: shop.name, object: shop}
        });
      },
      PropTypes.array
    ]
  }),
  takeLatest: ({ actions, workers }) => ({
    [actions.selectNewShop]: workers.changeShopWorker
  }),
  workers: {
    changeShopWorker: function * (action) {
      const { url, shop } = action.payload || {};
      try {

        yield put(configActions.setActiveShop(url, shop && shop.id));

        if(typeof window !== 'undefined') {
          window.location.reload(false);
        }

      } catch (e) {
        console.error(e);
      }
    }
  }
})
